import { useMutation } from '@tanstack/react-query';

type JobSourceUpdateRequest = {
  id: number;
  title?: string;
  login_id?: string;
  login_pass?: string;
  access_url?: string;
  basic_auth_id?: string;
  basic_auth_pass?: string;
  target_value?: string;
  target_type?: string;
  clear_login_credentials?: boolean;
  clear_basic_auth_credentials?: boolean;
};

export default function useUpdateJobSource() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({
      id,
      title,
      login_id,
      login_pass,
      access_url,
      basic_auth_id,
      basic_auth_pass,
      target_type,
      target_value,
      clear_login_credentials,
      clear_basic_auth_credentials,
    }: JobSourceUpdateRequest): Promise<void> => {
      const response = await fetch(`/agent/api/job_sources/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          login_id,
          login_pass,
          access_url,
          basic_auth_id,
          basic_auth_pass,
          target_type,
          target_value,
          clear_login_credentials,
          clear_basic_auth_credentials,
        }),
      });

      const data = await response.json();
      return data;
    },
  });
}
